module.exports = __webpack_public_path__ + "img/BC.651bbce6.svg";